import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './app/App';
import { logger } from './core/monitoring';
import env from './core/config/env';

// Log app initialization
logger.info('Application starting', {
    environment: env.ENVIRONMENT,
    version: env.APP_VERSION,
});

const rootElement = document.getElementById('root');

if (!rootElement) {
    throw new Error('Failed to find root element');
}

createRoot(rootElement).render(
    <StrictMode>
        <App />
    </StrictMode>
);
